export default __webpack_public_path__ + "static/nav-menu-bg-cad64f065ddcaf2fc48ac95065543bc0.jpg";